import React from "react";
import logo from "../../assets/logo.png";

export default function WelcomeMessage() {
  return (
    <>
      <h1>환영합니다!</h1>
      <img width="380" height="300" src={logo} alt="logo" />
      <div>보고싶은 영상을 찾아보세요.</div>
    </>
  );
}
